import { t, huidigeTaal } from '../i18n.js';

/**
 * De SOC-schermen, in het menu achter het rondje rechtsboven (zoals de klantkeuze): het volledige scherm of één sectie,
 * elk in een eigen venster. Een venster heeft een vaste naam: nog een keer kiezen brengt het bestaande naar voren in
 * plaats van een tweede te openen. Zie docs/besluiten/soc-scherm.md.
 */
const SECTIES = [['fw', 'Firewalls of klanten'], ['alerts', 'Open alerts'], ['map', 'Aanvallen (kaart)'],
  ['vpn', 'VPN'], ['changes', 'Wijzigingen en beheerlogins'], ['scans', 'Kwetsbaarheden (Nessus)'], ['ep', 'DNS Security, Secure Endpoint en Email Security'], ['s2s', 'Site-to-site-tunnels']];

export function openSoc({ paneel, code }) {
  const q = new URLSearchParams({ lang: huidigeTaal() });
  if (code) q.set('tenant', code);
  if (paneel) q.set('panel', paneel);
  const naam = `zero-soc-${code || 'alle'}-${paneel || 'alles'}`;
  const w = window.open(`/soc?${q}`, naam, `popup=yes,width=${paneel ? 1280 : 1920},height=${paneel ? 800 : 1080}`);
  if (w) w.focus();
}

/** Het blok SOC-scherm in het gebruikersmenu. `klaar` sluit het menu. */
export default function SocMenu({ klant, klantCode, klantNaam, klaar }) {
  const open = (x) => { klaar(); openSoc(x); };
  const code = klant !== 'alle' ? klantCode : null;
  return (
    <div className="menu-section">
      <span className="label">{t('SOC-scherm')}</span>
      <button type="button" role="menuitem" onClick={() => open({})}>{t('Volledig SOC-scherm')} <span className="muted">· {t('Alle klanten')}</span></button>
      {code && <button type="button" role="menuitem" onClick={() => open({ code })}>{t('Volledig SOC-scherm · {naam}', { naam: klantNaam })}</button>}
      <select className="menu-select" value="" aria-label={t('Eén sectie in een eigen venster')}
        onChange={(e) => e.target.value && open({ paneel: e.target.value, code })}>
        <option value="">{t('Eén sectie in een eigen venster')}…</option>
        {SECTIES.map(([k, l]) => <option key={k} value={k}>{t(l)}</option>)}
      </select>
    </div>
  );
}
